import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _VaDataTable } from "./VaDataTable-abfa71f4.mjs";
const VaDataTable = withConfigTransport(_VaDataTable);
export {
  VaDataTable as V
};
//# sourceMappingURL=index-23844500.mjs.map
